import { Controller } from "stimulus"

export default class extends Controller {

  static targets = []

  connect() {
    this.element.querySelector('.active-sidebar-item').scrollIntoView({block: 'center'});
   }

}